import { Action } from '@/_core/fluxstore/types';
import { ProductsState } from '../types';
import { useProductsStore } from '../useModule';
import { ChangeCurrentProduct } from './changeCurrentProduct';

const { registerReducer, registerMiddleware, dispatch } = useProductsStore();

export class ProductCreated extends Action<ProductsState> {
    public static ACTION_TYPE = 'ProductCreated';

    public constructor(public id: string, public slug: string, public name: string) {
        super(ProductCreated.ACTION_TYPE);
    }
}

const initAppDataMiddleware = async (state: ProductsState, action: ProductCreated): Promise<boolean> => {
    if (initAppData.isInWsContext) {
        initAppData.currentWs.products.push({
            id: action.id,
            slug: action.slug,
            name: action.name,
        });
    }

    return true;
};

const reducer = (state: ProductsState, action: ProductCreated): void => {
    state.products.push({
        id: action.id,
        slug: action.slug,
        name: action.name,
    });

    dispatch(new ChangeCurrentProduct(action.slug));
};

//@ts-ignore
registerMiddleware(ProductCreated.ACTION_TYPE, initAppDataMiddleware);

//@ts-ignore
registerReducer(ProductCreated.ACTION_TYPE, reducer);
